import React, { useEffect, useState } from "react"
import AdminDialog from "../AdminDialog"
import { Button, DateBox, SelectBox, TextBox } from "devextreme-react";
import { useSelector } from "react-redux";
import { makeStyles, Typography } from "@material-ui/core";
import { selectCampaignTypes } from "../../../redux/campaigns/selectors";
import { TaxonomySelector } from "./TaxonomySelector";
import { generate } from "generate-password-browser";
import dayjs from "dayjs";

const useStyles = makeStyles({
    label: {
        color: "#333"
    },
  });

const initialData = {
    campaignName: "",
    startDate: null,
    endDate: null,
    campaignTypeId: null,
    taxonomies: []
}


function InputWrapper(props){
    const {classes, label} = props;
        return (
            <div className="dx-field">
                <label className={classes.label}>{label}</label> 
                <div style={{width:"50%"}} className="dx-field-value">
                    {props.children}
                </div>
            </div>
        )
}


function CampaignsDialogue(props){

const {operation, data, open, handleDialogClose, onSubmitOperation} = props;
const [editData, setEditData] = useState(initialData);
const campaignTypes = useSelector(selectCampaignTypes)
const classes = useStyles();
const title = operation === "create" ? "Adicionar Campanha" : operation === "edit" ? "Editar Campanha" : "Desativar Campanha"
const disabledStartDate = dayjs(editData.startDate).isBefore(dayjs(), "date");


useEffect(()=>{
    if(open && data){
        setEditData(data)
    } else {
        setEditData(initialData)
    }

},[data, open])

function handleEditField(key, value){
    setEditData(editData=>({...editData, [key]: value}))
}

function handleChangeType(value){
    handleEditField("campaignTypeId", value)
}

function handleTaxonomiesChange(newTaxonomyValue, externalTaxonomyId) {
    const newValues = editData.taxonomies.map(t=> t.externalId === externalTaxonomyId ? ({...t, 
        level_1: newTaxonomyValue.taxonomyLevel_1,
        level_2: newTaxonomyValue.taxonomyLevel_2,
        level_3: newTaxonomyValue.taxonomyLevel_3,
        level_4: newTaxonomyValue.taxonomyLevel_4}
    ) :  ({...t}) )
    setEditData(prevState => ({
        ...prevState,
        taxonomies : newValues
    }));
}

function handleRejectTaxonomyChange(newTaxonomyValue) {
    const newValue = {
        level_1: newTaxonomyValue.taxonomyLevel_1,
        level_2: newTaxonomyValue.taxonomyLevel_2,
        level_3: newTaxonomyValue.taxonomyLevel_3,
        level_4: newTaxonomyValue.taxonomyLevel_4}

    setEditData(prevState => ({
        ...prevState,
        rejectTaxonomy : newValue
    }));
}


function handleAddTaxonomy(){
  const taxonomies = [...editData.taxonomies];
  const newTaxonomy = {
    level_1: null,
    level_2: null,
    level_3: null,
    level_4: null,
    externalId: generate({length: 8})
}

  taxonomies.push(newTaxonomy);  
  setEditData(prevData=> ({...prevData, taxonomies: taxonomies}))
}

function handleDeleteTaxonomy(internalTaxonomyId)
{
   const withoutDeletedTax = editData.taxonomies.filter(tax=> tax.externalId !== internalTaxonomyId)
    setEditData(prevState=> ({...prevState, taxonomies: withoutDeletedTax}))
}

return(
        <AdminDialog dialogSize={{height: "100%", width: "900px"}} operation = { operation } open = { open } onClose = { handleDialogClose } title = {title} 
                data = { editData } handleOnClick = { ()=>onSubmitOperation(editData) }>
                { operation === 'delete'
                    ?   <Typography>
                            {`A campanha ${editData.campaignName} será removida.`}
                        </Typography>
                    : 
                        <>                  
                            <InputWrapper classes = {classes} label = {"Nome"}>
                                <TextBox height={35} value={editData.campaignName} onValueChanged={(e)=>{handleEditField("campaignName", e.value)}}/>
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {"Tipo"}>
                                <SelectBox
                                    dataSource = { campaignTypes }
                                    value = { editData.campaignTypeId}
                                    displayExpr = { "description" }
                                    valueExpr = { "campaignTypeId" }
                                    onValueChanged = { (e) => handleChangeType(e.value) }
                                    searchEnabled = { true }
                                    showClearButton= {false}
                                >
                                </SelectBox>
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {"Data de início"}>
                                <DateBox  dateSerializationFormat="yyyy-MM-dd" height={35} disabled={disabledStartDate} min={disabledStartDate ? null : dayjs().startOf("date")} max={editData.endDate} value={editData.startDate} onValueChanged={(e)=>{handleEditField("startDate", e.value)}}/>
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {"Data final"}>
                                <DateBox  dateSerializationFormat="yyyy-MM-dd" height={35} min={editData.startDate} value={editData.endDate} onValueChanged={(e)=>{handleEditField("endDate", e.value)}}/>
                            </InputWrapper>
                            <div>
                            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                <div className="dx-field" style={{color: "#333" }} >Taxonomias:</div>
                                <div><Button icon="add" text="Adicionar taxonomia" onClick={handleAddTaxonomy}></Button></div>
                            </div>
                                {editData.taxonomies.length > 0 && editData.taxonomies.map((t, i)=> 
                                <div style={{padding: "6px", backgroundColor: i%2===0 ? "white" : "#DBE6E0" }}>
                                    <TaxonomySelector index={i} selectedTaxonomy={t} handleDeleteTaxonomy={handleDeleteTaxonomy}  handleTaxonomiesChange={handleTaxonomiesChange}/>
                                </div>
                                )}  
                            </div>
                            <div>
                                <div className="dx-field" style={{color: "#333" }} >Taxonomia de rejeição:</div>
                                <TaxonomySelector selectedTaxonomy={editData.rejectTaxonomy} handleTaxonomiesChange={handleRejectTaxonomyChange}/>  
                            </div>

                            
                            
                        </>
            }
        </AdminDialog>
    )

}

export {CampaignsDialogue}